export const useOrderStore = defineStore("order", {
  state() {
    return {
      orderPayObject: {},
      countryObject: {}, // 国家
      stateObject: {}, // 地区
      erpOrderEmail: "" // erp订单邮箱
    }
  },

  actions: {
    setOrderPayObject(object = {}) {
      this.orderPayObject = object
    },
    setCountryObject(object = {}) {
      this.countryObject = object
    },
    setStateObject(object = {}) {
      this.stateObject = object
    },
    setErpOrderEmail(email = "") {
      this.erpOrderEmail = email
    }
  },
  persist: true
})
